// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:390px){.hero-content[data-v-07cff753]{flex-direction:row}}.dropdown[data-v-07cff753] :first-child{background-color:#fcfcfc}.purpleGradient[data-v-07cff753]{-webkit-text-fill-color:transparent;background:#30074d;background:linear-gradient(90deg,#30074d 0,#57088f);-webkit-background-clip:text}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
